export default __webpack_public_path__ + "static/media/tragsatec-logo.c212916d.png";